import type { FC } from 'react';
import { useRef } from 'react';

import { useScrollNavigationContext } from '../../hooks/useScrollNavigation/index.ts';
import { Item, VerticalNavigationGroupWrapper } from './components/index.ts';
import { Wrapper } from './styled.ts';

export const VerticalNavigationGroup: FC = () => {
  const { activeId, scrollToSection, sections } = useScrollNavigationContext();
  const wrapperRef = useRef<HTMLDivElement>(null);

  return (
    <Wrapper ref={wrapperRef}>
      {sections.map(({ id, title, error, dataTestId }, index) => (
        <Item
          key={id}
          id={id}
          index={index}
          title={title}
          active={id === activeId}
          error={error}
          setActiveId={scrollToSection}
          dataTestId={dataTestId}
        />
      ))}
    </Wrapper>
  );
};

export { VerticalNavigationGroupWrapper };
